import Api from '@/data';
import Constants from '@/utils/constants';
import * as apiName from '@/data/apiEndpointNames';
class ApiService {
	static getBusinessSuperCategoryList = () =>
		Api.apiWebClient.get(apiName.getBusinessSuperCategoryList.endPoint);

	// Same API call is used for category and sub category list
	static getBusinessCategoryList = (categoryNodeId) =>
		Api.apiWebClient.get(apiName.getBusinessCategoryList.endPoint, {
			routeParams: { categoryNodeId },
		});

	static getPincodeDetails = (pincode) =>
		Api.apiWebClient.get(apiName.getPincodeDetails.endPoint, {
			routeParams: { pincode },
		});

	static updateMerchantDetails = (data) =>
		Api.apiWebClient.patch(apiName.updateMerchantDetails.endPoint, { data });

	static kycInit = (data) =>
		Api.apiWebClient.post(apiName.kycInit.endPoint, { data });

	static getKycStatus = (data) =>
		Api.apiWebClient.post(apiName.getKycStatus.endPoint, { data });

	static emailVerification = (data) =>
		Api.apiWebClient.post(apiName.sentEmailVerification.endPoint, { data });

	static sendOtp = (data) => {
		const { captcha } = data;
		delete data.captcha;
		return Api.apiWebClient.post(apiName.sendOtp.endPoint, {
			data: {
				type: 'OTP',
				phoneNumber: data.phone,
				email: data.email,
				deviceFingerprint: Constants.DEVICE_FINGER_PRINT,
				...data.metadata,
			},
			headers: {
				[Constants.HCAPTCHA_HEADER_KEY]: captcha,
			},
		});
	};

	static submitOtp = (data) =>
		Api.apiWebClient.post(apiName.submitOtp.endPoint, {
			data: {
				type: 'OTP',
				deviceFingerprint: Constants.DEVICE_FINGER_PRINT,
				...data,
			},
		});

	static initServiceLine = ({ merchantId, solutionType }) =>
		Api.apiWebClient.post(apiName.initServiceLine.endPoint, {
			data: {
				merchantId,
				serviceLineType: solutionType,
			},
		});

	static getServiceLinesList = (merchantId) =>
		Api.apiWebClient.get(apiName.getServiceLinesList.endPoint, {
			routeParams: { merchantId },
		});
}
export default ApiService;
